//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CheckboxField',
  props: {
    value: Boolean,
    label: String,
    name: String,
    error: '',
  },
  methods: {
    updateValue: function () {
      this.$emit('input', !this.value);
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/fields/CheckboxField.vue